import FaceUSBTokenActivateModal from './FaceUSBTokenActivateModal';

export default FaceUSBTokenActivateModal;
